import * as React from 'react';
export const checkSvg = React.forwardRef(function checkSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.736 1.179a.75.75 0 0 1 .085 1.057l-4.25 5a.75.75 0 0 1-1.151-.011L.17 4.475a.75.75 0 1 1 1.16-.95L3.011 5.58l3.668-4.315a.75.75 0 0 1 1.057-.085Z',
    }),
  );
});
checkSvg.defaultProps = {
  width: '8',
  height: '8',
  viewBox: '0 0 8 8',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var check = {
  category: 'icon',
  colorable: true,
  name: 'check',
  svg: checkSvg,
};
